(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noce-iade"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('noce-iade')) {
    // Tür bazlı metinler (30.10 adım 6). Tür/sebep/kanıt kuralları Worker'dan (/dogrula → turler) gelir; burada yalnız müşteriye görünen cümleler.
    const KOSUL = {
      iade: 'İade edilecek ürün kullanılmamış olmalı; kutusu ve tüm aksesuarlarıyla birlikte eksiksiz gönderilmelidir. Onay gelmeden ürünü kargoya vermeyin.',
      garanti: 'Garanti kapsamında önce uzaktan çözüm deneriz; gerekirse parça gönderir, ürünü incelemeye alır ya da değiştiririz. Kullanım hatası ve darbe kaynaklı hasarlar garanti dışındadır.',
      degisim: 'Hasarlı ya da yanlış gelen ürünü, kutusu ve aksesuarlarıyla birlikte hazır tutun; inceleme sonrası size gönderim adımlarını yazacağız.',
      eksik: 'Eksik bildiriminiz depo paketleme kaydıyla karşılaştırılır; eksik çıkan ürün ek ücret olmadan gönderilir.'
    };
    const TAMAM = {
      iade: '<p>Fotoğraflarınızı inceledikten sonra siparişteki telefon numaranız üzerinden size dönüş yapacağız. İadeniz onaylanırsa ürünü ücretsiz gönderebileceğiniz kargo kodunu ve gönderim adımlarını ileteceğiz. Ürünü bizden onay almadan kargoya vermeyin.</p>',
      garanti: '<p>Videonuzu ve fotoğraflarınızı inceleyip siparişteki telefon numaranızdan size yazacağız. Çoğu arızayı uzaktan bir ayarla çözüyoruz; çözülmezse parça gönderimi, inceleme ya da değişim adımlarını birlikte belirleyeceğiz.</p>',
      degisim: '<p>Fotoğraflarınızı inceleyip siparişteki telefon numaranızdan size yazacağız. Değişim onaylanırsa gönderim adımlarını ve kargo kodunu ileteceğiz; ürünü bizden onay almadan kargoya vermeyin.</p>',
      eksik: '<p>Bildiriminizi depomuzun paketleme kaydıyla karşılaştırıyoruz. Eksik çıkan ürünü ek ücret olmadan kargoya verip siparişteki telefon numaranızdan takip bilgisini yazacağız.</p>'
    };
    const KALEM_BASLIK = { iade: 'Hangi ürünü iade etmek istiyorsunuz?', garanti: 'Hangi üründe sorun var?', degisim: 'Hangi ürün hasarlı / yanlış geldi?', eksik: 'Hangi ürün ya da parçası eksik?' };
    customElements.define('noce-iade', class extends HTMLElement {
      connectedCallback() {
        this.api = (this.dataset.api || '').replace(/\/$/, '');
        this.crm = (this.dataset.crm || '').replace(/\/$/, '');
        this.durum = { dosyalar: {}, kod: { gerekli: false, dogrulandi: false, jeton: '' } };
        this.querySelectorAll('form[data-adim]').forEach((f) => f.addEventListener('submit', (e) => { e.preventDefault(); this.ileri(Number(f.dataset.adim)); }));
        this.querySelectorAll('[data-geri]').forEach((b) => b.addEventListener('click', () => this.git(Number(b.closest('[data-adim]').dataset.adim) - 1)));
        this.$('[data-kod-yeniden]').addEventListener('click', () => this.kodGonder(true));
      }
      $(s) { return this.querySelector(s); }
      uyari(m) { const u = this.$('[data-uyari]'); u.textContent = m || ''; u.hidden = !m; if (m) u.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      git(n) {
        this.uyari('');
        this.querySelectorAll('[data-adim]').forEach((k) => { k.hidden = Number(k.dataset.adim) !== n; });
        this.querySelectorAll('[data-adim-gosterge]').forEach((g) => { const i = Number(g.dataset.adimGosterge); g.classList.toggle('is-aktif', i === n); g.classList.toggle('is-bitti', i < n); });
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      async istek(yol, govde, json, taban) {
        const r = await fetch((taban === undefined ? this.api : taban) + yol, json ? { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(govde) } : { method: 'POST', body: govde });
        const d = await r.json().catch(() => ({ ok: false, hata: 'Bağlantı hatası, lütfen tekrar deneyin.' }));
        if (!d.ok) throw new Error(d.hata || 'Bir hata oldu, lütfen tekrar deneyin.');
        return d;
      }
      bekle(buton, acik, yazi) { if (acik) { buton.dataset.eski = buton.textContent; buton.textContent = yazi; buton.disabled = true; } else { buton.textContent = buton.dataset.eski || buton.textContent; buton.disabled = false; } }
      async kodGonder(yeniden) {
        const d = await this.istek('/iade/kod', { siparis_no: this.durum.siparis_no, telefon: this.durum.telefon }, true, this.crm);
        this.$('[data-tel-maske]').textContent = d.maske || this.durum.tel_maske || '';
        this.$('[data-kod]').hidden = false;
        this.$('[data-adim1]').textContent = 'Kodu doğrula';
        this.$('input[name=kod]').focus();
        if (yeniden) this.uyari('Yeni kod gönderildi. Kodun gelmesi bir dakika sürebilir.');
      }
      async ileri(n) {
        const f = this.$(`form[data-adim="${n}"]`);
        const buton = f.querySelector('[type=submit]');
        this.uyari('');
        try {
          if (n === 1) {
            if (this.durum.kod.gerekli && !this.durum.kod.dogrulandi && !this.$('[data-kod]').hidden) {
              const kod = f.kod.value.replace(/\D/g, '');
              if (kod.length !== 6) return this.uyari('WhatsApp ile gelen 6 haneli kodu yazın.');
              this.bekle(buton, true, 'Doğrulanıyor…');
              const d = await this.istek('/iade/kod/dogrula', { siparis_no: this.durum.siparis_no, telefon: this.durum.telefon, kod }, true, this.crm);
              Object.assign(this.durum.kod, { dogrulandi: true, jeton: d.jeton });
              this.adim2Kur();
              this.git(2);
              return;
            }
            const no = f.siparis_no.value.trim(), tel = f.telefon.value.trim();
            if (!no || !tel) return this.uyari('Sipariş numaranızı ve telefon numaranızı yazın.');
            this.bekle(buton, true, 'Siparişiniz aranıyor…');
            const d = await this.istek('/dogrula', { siparis_no: no, telefon: tel }, true);
            Object.assign(this.durum, { siparis_no: d.siparis_no, telefon: tel, tel_maske: d.tel_maske, kapida: d.kapida, turler: d.turler, kalemler: d.kalemler, tur: null, dosyalar: {} });
            this.durum.kod = { gerekli: !!d.kod_gerekli && !!this.crm, dogrulandi: false, jeton: '' };
            if (this.durum.kod.gerekli) { await this.kodGonder(false); return; }
            this.adim2Kur();
            this.git(2);
          } else if (n === 2) {
            const tur = f.querySelector('input[name=tur]:checked');
            if (!tur) return this.uyari('Talep türünü seçin.');
            const T = this.durum.turler[tur.value];
            const secili = [...f.querySelectorAll('input[name=kalem]:checked')].map((x) => x.value);
            const sebep = f.querySelector('input[name=sebep]:checked');
            const aciklama = f.aciklama.value.trim();
            if (!secili.length) return this.uyari('İlgili ürünü seçin.');
            if (!sebep) return this.uyari('Sebebi seçin.');
            const s = T.sebepler.find((x) => x.kod === sebep.value);
            if (T.aciklama.includes(s.kod) && aciklama.length < 10) return this.uyari('Yaşadığınız durumu birkaç cümleyle yazın.');
            Object.assign(this.durum, { tur: tur.value, secili, sebep: s, aciklama });
            this.adim3Kur();
            this.git(3);
          } else if (n === 3) {
            const eksik = this.roller().filter((r) => r.zorunlu && !(this.durum.dosyalar[r.rol] || []).length);
            this.querySelectorAll('.niade__foto').forEach((k) => k.classList.toggle('is-eksik', eksik.some((r) => r.rol === k.dataset.rol)));
            if (eksik.length) return this.uyari('İşaretli bölümlere en az bir dosya ekleyin.');
            const T = this.durum.turler[this.durum.tur];
            this.$('[data-iban]').hidden = !(T.iban && this.durum.kapida);
            this.$('[data-kosul]').textContent = KOSUL[this.durum.tur] || '';
            this.ozetYaz();
            this.git(4);
          } else if (n === 4) {
            const T = this.durum.turler[this.durum.tur];
            const fd = new FormData();
            fd.append('siparis_no', this.durum.siparis_no);
            fd.append('telefon', this.durum.telefon);
            fd.append('tur', this.durum.tur);
            fd.append('jeton', this.durum.kod.jeton || '');
            fd.append('kalemler', this.durum.secili.join(','));
            fd.append('sebep', this.durum.sebep.kod);
            fd.append('aciklama', this.durum.aciklama);
            fd.append('web_sitesi', f.web_sitesi.value);
            if (T.iban && this.durum.kapida) {
              const iban = f.iban.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
              if (f.hesap_sahibi.value.trim().split(/\s+/).length < 2) return this.uyari('Hesap sahibinin adını ve soyadını yazın.');
              if (!this.ibanGecerli(iban)) return this.uyari('IBAN numarası hatalı görünüyor. TR ile başlayan 26 karakterlik numarayı kontrol edin.');
              fd.append('iban', iban);
              fd.append('hesap_sahibi', f.hesap_sahibi.value.trim());
            }
            this.roller().forEach((r) => (this.durum.dosyalar[r.rol] || []).forEach((b, i) => fd.append(`${r.video ? 'video' : 'foto'}_${r.rol}`, b, `${r.rol}-${i + 1}.${r.video ? 'mp4' : 'jpg'}`)));
            this.bekle(buton, true, 'Gönderiliyor…');
            const d = await this.istek('/talep', fd, false);
            this.$('[data-talep-no]').textContent = d.talep_no;
            this.$('[data-tamam]').innerHTML = TAMAM[this.durum.tur] || TAMAM.iade;
            this.git(5);
          }
        } catch (e) {
          this.uyari(e.message);
        } finally {
          this.bekle(buton, false);
        }
      }
      roller() {
        const T = this.durum.turler[this.durum.tur];
        const r = T.foto.slice();
        if (T.kusur_foto && this.durum.sebep && this.durum.sebep.kusur) r.push({ rol: 'kusur', zorunlu: true, baslik: 'Sorunlu bölgenin yakın çekimi', aciklama: 'Kırık, çatlak ya da sorun yaşadığınız bölgeyi yakından çekin.' });
        return r;
      }
      adim2Kur() {
        const tl = this.$('[data-turler]');
        tl.replaceChildren(...Object.entries(this.durum.turler).map(([kod, t]) => {
          const l = document.createElement('label');
          l.className = 'niade__tur' + (t.uygun ? '' : ' is-pasif');
          l.innerHTML = '<input type="radio" name="tur"><span><b></b><small></small><small class="neden"></small></span>';
          const i = l.querySelector('input'); i.value = kod; i.disabled = !t.uygun;
          l.querySelector('b').textContent = t.ad; l.querySelectorAll('small')[0].textContent = t.alt; l.querySelector('.neden').textContent = t.uygun ? '' : t.neden;
          i.addEventListener('change', () => this.turSec(kod));
          return l;
        }));
        const uygun = Object.entries(this.durum.turler).filter(([, t]) => t.uygun);
        if (uygun.length === 1) { tl.querySelector(`input[value="${uygun[0][0]}"]`).checked = true; this.turSec(uygun[0][0]); }
        else { this.$('[data-sebepler]').replaceChildren(); this.$('[data-kalemler]').replaceChildren(); }
      }
      turSec(kod) {
        const T = this.durum.turler[kod];
        this.$('[data-kalem-grup] legend').textContent = KALEM_BASLIK[kod] || 'İlgili ürün';
        const k = this.$('[data-kalemler]');
        k.replaceChildren(...this.durum.kalemler.map((x) => {
          const l = document.createElement('label');
          l.className = 'niade__kalem';
          l.innerHTML = '<input type="checkbox" name="kalem"><img alt="" loading="lazy"><span></span>';
          l.querySelector('input').value = x.id;
          l.querySelector('input').checked = this.durum.kalemler.length === 1;
          if (x.gorsel) l.querySelector('img').src = x.gorsel; else l.querySelector('img').remove();
          l.querySelector('span').textContent = x.adet > 1 ? `${x.ad} (${x.adet} adet)` : x.ad;
          return l;
        }));
        const s = this.$('[data-sebepler]');
        s.replaceChildren(...T.sebepler.map((x) => {
          const l = document.createElement('label');
          l.className = 'niade__sebep';
          l.innerHTML = '<input type="radio" name="sebep"><span></span>';
          l.querySelector('input').value = x.kod;
          l.querySelector('span').textContent = x.ad;
          l.querySelector('input').addEventListener('change', () => {
            this.$('[data-aciklama-etiket]').textContent = T.aciklama.includes(x.kod) ? 'Açıklama' : 'Açıklama (isteğe bağlı)';
          });
          return l;
        }));
        this.$('[data-aciklama-etiket]').textContent = 'Açıklama (isteğe bağlı)';
      }
      adim3Kur() {
        const kap = this.$('[data-fotolar]');
        this.durum.dosyalar = {};
        kap.replaceChildren(...this.roller().map((r) => {
          const d = document.createElement('div');
          d.className = 'niade__foto'; d.dataset.rol = r.rol;
          d.innerHTML = '<div class="niade__foto-bas"><strong></strong><em></em></div><p></p><div class="niade__onizleme" data-onizleme></div><label class="niade__yukle"><input type="file" hidden>+ Ekle</label>';
          d.querySelector('strong').textContent = r.baslik; d.querySelector('em').textContent = r.zorunlu ? 'Zorunlu' : 'İsteğe bağlı'; d.querySelector('p').textContent = r.aciklama;
          const i = d.querySelector('input'); i.accept = r.video ? 'video/*' : 'image/*'; if (!r.video) i.multiple = true;
          d.querySelector('label').lastChild.textContent = r.video ? '+ Video ekle' : '+ Fotoğraf ekle';
          i.addEventListener('change', (e) => this.dosyaEkle(r, e.target));
          return d;
        }));
      }
      async kucult(dosya) {
        try {
          const bmp = await createImageBitmap(dosya);
          const o = Math.min(1, 1600 / Math.max(bmp.width, bmp.height));
          const c = document.createElement('canvas');
          c.width = Math.round(bmp.width * o); c.height = Math.round(bmp.height * o);
          c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
          const b = await new Promise((r) => c.toBlob(r, 'image/jpeg', 0.82));
          if (b) return b;
        } catch (e) {}
        if (dosya.size <= 6 * 1024 * 1024 && /^image\//.test(dosya.type)) return dosya;
        throw new Error('Bu fotoğraf açılamadı. Lütfen başka bir fotoğraf seçin ya da ekran görüntüsü olarak ekleyin.');
      }
      async dosyaEkle(r, girdi) {
        this.uyari('');
        const liste = (this.durum.dosyalar[r.rol] ||= []);
        if (r.video) {
          const d = girdi.files[0];
          if (d) {
            if (!/^video\//.test(d.type)) this.uyari('Lütfen bir video dosyası seçin.');
            else if (d.size > 40 * 1024 * 1024) this.uyari('Video çok büyük (en çok 40 MB). Daha kısa bir video çekin.');
            else liste.splice(0, liste.length, d);
          }
        } else {
          const toplam = Object.entries(this.durum.dosyalar).reduce((a, [k, x]) => a + (this.roller().find((q) => q.rol === k && q.video) ? 0 : x.length), 0);
          const dosyalar = [...girdi.files].slice(0, Math.max(0, 9 - toplam));
          if (girdi.files.length > dosyalar.length) this.uyari('En fazla 9 fotoğraf ekleyebilirsiniz.');
          for (const d of dosyalar) {
            try { liste.push(await this.kucult(d)); } catch (e) { this.uyari(e.message); }
          }
        }
        girdi.value = '';
        this.onizle(r);
      }
      onizle(r) {
        const kap = this.$(`.niade__foto[data-rol="${r.rol}"]`);
        kap.classList.remove('is-eksik');
        const o = kap.querySelector('[data-onizleme]');
        o.querySelectorAll('img, video').forEach((i) => URL.revokeObjectURL(i.src));
        o.replaceChildren(...(this.durum.dosyalar[r.rol] || []).map((b, i) => {
          const d = document.createElement('div');
          d.className = 'niade__kucuk';
          d.innerHTML = (r.video ? '<video muted playsinline></video>' : '<img alt="">') + '<button type="button" aria-label="Kaldır">×</button>';
          d.querySelector(r.video ? 'video' : 'img').src = URL.createObjectURL(b);
          d.querySelector('button').addEventListener('click', () => { this.durum.dosyalar[r.rol].splice(i, 1); this.onizle(r); });
          return d;
        }));
      }
      ozetYaz() {
        const T = this.durum.turler[this.durum.tur];
        const ad = this.durum.kalemler.filter((x) => this.durum.secili.includes(x.id)).map((x) => x.ad).join(', ');
        const adet = Object.values(this.durum.dosyalar).reduce((a, x) => a + x.length, 0);
        const satirlar = [['Sipariş', this.durum.siparis_no], ['Talep', T.ad], ['Ürün', ad], ['Sebep', this.durum.sebep.ad], ['Dosya', `${adet} adet`]];
        this.$('[data-ozet]').replaceChildren(...satirlar.map(([k, v]) => { const p = document.createElement('div'); const b = document.createElement('strong'); b.textContent = `${k}: `; p.append(b, v); return p; }));
      }
      ibanGecerli(n) {
        if (!/^TR\d{24}$/.test(n)) return false;
        const y = (n.slice(4) + n.slice(0, 4)).replace(/[A-Z]/g, (c) => String(c.charCodeAt(0) - 55));
        let k = 0;
        for (const ch of y) k = (k * 10 + Number(ch)) % 97;
        return k === 1;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
